import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-input" }
const _hoisted_2 = {
  key: 0,
  class: "skeleton-wrapper",
  "data-test": "skeleton-wrapper"
}
const _hoisted_3 = { key: 0 }

import {
  ref,
  onMounted,
  getCurrentInstance,
  onUpdated,
} from "vue";
import {
  IonItem,
  IonLabel,
  IonInput,
  IonNote,
  IonSkeletonText,
} from "@ionic/vue";

import { TextFieldTypes } from "@ionic/core";

interface Props {
  inputType?: TextFieldTypes;
  value: string | number;
  labelText?: string;
  placeholderText?: string;
  helperText?: string;
  errorText?: string;
  required?: boolean;
  isLoading: boolean;
  disabled?: boolean;
  readonly?: boolean;
  errorIdPrefix?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    inputType: {},
    value: {},
    labelText: {},
    placeholderText: {},
    helperText: {},
    errorText: {},
    required: { type: Boolean, default: false },
    isLoading: { type: Boolean },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    errorIdPrefix: { default: "error-message" }
  },
  emits: ["onChange", "onBlur", "onUpdate"],
  setup(__props: any, { emit: __emit }) {



onUpdated(() => {
  emit("onUpdate");
});

const emit = __emit;

const uid = ref<number | null | undefined>(null);
onMounted(() => {
  uid.value = getCurrentInstance()?.uid;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonSkeletonText), {
            animated: true,
            class: "skeleton-label"
          }),
          _createVNode(_unref(IonSkeletonText), {
            animated: true,
            class: "skeleton-input"
          })
        ]))
      : (_openBlock(), _createBlock(_unref(IonItem), {
          key: 1,
          class: "input-item",
          "data-test": "input-item",
          lines: "none"
        }, {
          default: _withCtx(() => [
            (__props.labelText)
              ? (_openBlock(), _createBlock(_unref(IonLabel), {
                  key: 0,
                  "aria-hidden": "true",
                  position: "stacked",
                  "data-test": "input-label",
                  class: _normalizeClass(["input-label", { disabled: __props.disabled, readonly: __props.readonly }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.labelText) + " ", 1),
                    (__props.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.$t("resume.requiredLabel")) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonInput), {
              class: _normalizeClass(["input-field", { disabled: __props.disabled, readonly: __props.readonly }]),
              type: __props.inputType,
              placeholder: __props.placeholderText,
              onIonChange: _cache[0] || (_cache[0] = ($event: any) => (emit('onChange', $event))),
              onIonBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('onBlur', $event))),
              value: __props.value,
              required: __props.required,
              disabled: __props.disabled,
              readonly: __props.readonly,
              "data-test": "text-input",
              "aria-describedby": `${__props.errorIdPrefix}-${uid.value}`
            }, null, 8, ["class", "type", "placeholder", "value", "required", "disabled", "readonly", "aria-describedby"]),
            (__props.helperText)
              ? (_openBlock(), _createBlock(_unref(IonNote), {
                  key: 1,
                  class: _normalizeClass(["helper-text", { disabled: __props.disabled, readonly: __props.readonly }]),
                  slot: "helper",
                  "data-test": "helper-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.helperText), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (__props.errorText && !__props.disabled && !__props.readonly)
              ? (_openBlock(), _createBlock(_unref(IonNote), {
                  key: 2,
                  "aria-hidden": "true",
                  id: `${__props.errorIdPrefix}-${uid.value}`,
                  slot: "error",
                  class: "error-text",
                  "data-test": "error-text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.errorText), 1)
                  ]),
                  _: 1
                }, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
  ]))
}
}

})